<header class="">
    <div class="p-fluid p-formgrid justify-content-center top-header-sec" style="display: flex; flex-wrap:wrap">
        <!-- <div class="field col-sm-12 col-md-6 col-lg-3 col-xl-3 my-0 py-0 mx-0 px-0"> -->
        <div class="field sm:col-6 md:col-1 lg:col-1 my-0 py-0 mx-0 px-0 logo-continer">
            <img src="../../../assets/activitiesImages/micada_new_logo.png">
        </div>
        <div class="p-fluid p-formgrid justify-content-center field sm:col-12 md:col-10 lg:col-10 my-0 py-0 mx-0 px-2" style="display: flex; flex-wrap:wrap">
            <div class="field sm:col-12 md:col-12 lg:col-12 my-0 py-0 mx-0 px-0 micada-heading">
                <p>{{'MICADA_HEADING'| translate}}</p>
            </div>
            <div class="field sm:col-12 md:col-12 lg:col-12 my-0 py-0 mx-0">
                <!-- Language Translation and Social Icons Section -->
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <div class="field sm:col-6 md:col-6 lg:col-6 my-0 py-0">
                        <div class="language-translation social-icons d-flex">
                            <label>{{ 'LANGUAGE' | translate }}</label>
                            <p-dropdown [(ngModel)]="selectedLang"
                                [options]='[{name: "English", code:"en"}, {name: "Hindi", code:"hd"}]' optionLabel="name"
                                (onChange)="languageChange($event)">
                            </p-dropdown>
                        </div>
                    </div>
    
                    <div class="field sm:col-6 md:col-6 lg:col-6 my-0 py-0 px-2">
                        <div class="language-translation social-icons d-flex">
                            <span class="">{{ "FOLLOW_US" | translate }}</span>
                            <a href="https://www.facebook.com/share/12BhJki9f8j/?mibextid=LQQJ4d" target="_blank">
                                <img src="../../../assets/home/logo/facebook.png" alt="Facebook" class="social-icon" />
                            </a>
                            <a href="https://x.com/Micadaharyana" target="_blank">
                                <img src="../../../assets/home/logo/x.png" alt="X (Twitter)" class="social-icon" />
                            </a>
                            <!-- <a href="https://www.instagram.com/" target="_blank">
                                <img src="../../../assets/home/logo/instagram.png" alt="Intagram" class="social-icon" />
                            </a>
                            <a href="https://www.youtube.com/" target="_blank">
                                <img src="../../../assets/home/logo/youtube.png" alt="Youtube" class="social-icon" />
                            </a> -->
                        </div>
                    </div>
                </div>
    
                <!-- </div> -->
            </div>
        </div>
        <div class="field sm:col-2 md:col-1 lg:col-1 my-0 py-0 mx-0 px-0 logo-continer hide-small">
            <img src="../../../assets/activitiesImages/logo.png">
        </div>
        <!-- <div class="field sm:col-12 md:col-2 lg:col-1 my-0 py-0 mx-0 px-0 hide-small hide-medium">
        <img src="../../../assets/activitiesImages/Azadi-Ka-Amrit-Mahotsav-Logo.png"
          style="width: 120px; height: 90px; object-fit: contain;">
      </div> -->

        <!-- <div class="field sm:col-12 md:col-12 lg:col-2 my-0 py-0 mx-0">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <div class="field sm:col-6 md:col-6 lg:col-6 my-0 py-0">
                    <div class="language-translation social-icons d-flex">
                        <label>{{ 'LANGUAGE' | translate }}</label>
                        <p-dropdown [(ngModel)]="selectedLang"
                            [options]='[{name: "English", code:"en"}, {name: "Hindi", code:"hd"}]' optionLabel="name"
                            (onChange)="languageChange($event)">
                        </p-dropdown>
                    </div>
                </div>

                <div class="field sm:col-6 md:col-6 lg:col-6 my-0 py-0 px-2">
                    <div class="language-translation social-icons d-flex">
                        <span class="">{{ "FOLLOW_US" | translate }}</span>
                        <a href="https://www.facebook.com/share/12BhJki9f8j/?mibextid=LQQJ4d" target="_blank">
                            <img src="../../../assets/home/logo/facebook.png" alt="Facebook" class="social-icon" />
                        </a>
                        <a href="https://x.com/Micadaharyana" target="_blank">
                            <img src="../../../assets/home/logo/x.png" alt="X (Twitter)" class="social-icon" />
                        </a>
                        <a href="https://www.instagram.com/" target="_blank">
                            <img src="../../../assets/home/logo/instagram.png" alt="Intagram" class="social-icon" />
                        </a>
                        <a href="https://www.youtube.com/" target="_blank">
                            <img src="../../../assets/home/logo/youtube.png" alt="Youtube" class="social-icon" />
                        </a>
                    </div>
                </div>
            </div>

        </div> -->
    </div>
    <!-- <div class="top-header-sec w3-container w3-padding-12">
      <div class="row">
        <div class="w3-left w3-margin-top w3-padding-12" style="width: 150px;">
          <img src="../../../assets/activitiesImages/micada_new_logo.png"
            style="width: 150px; height: 90px; object-fit: contain;">
        </div>
        <div class="w3-col m5">
          <h3 style="font-weight:bold; margin-bottom:0px; margin-top:30px; color: #fbac1b; font-size: 1.4rem;">
            {{'MICADA_HEADING'| translate}}</h3>
        </div>
        <div class="w3-left w3-margin-top w3-padding-12 w3-hide-small" style="width: 130px;">
          <img src="../../../assets/activitiesImages/Swachh-Bharat-Logo.png"
            style="width: 120px; height: 90px; object-fit: contain;">
        </div>
        <div class="w3-left w3-margin-top w3-padding-12 w3-hide-small" style="width: 130px;">
          <img src="../../../assets/activitiesImages/Azadi-Ka-Amrit-Mahotsav-Logo.png"
            style="width: 120px; height: 90px; object-fit: contain;">
        </div>
      </div>
  
  
      <div class="w6-col m3 w3-right button-div d-flex" style="text-align: right;">
        <button type="button" class="button-33" [ngStyle]="{'font-size': '0.7rem'}"><a
            [routerLink]="['/login']"><b>{{'LOGIN'|
              translate}}</b></a></button>
        <button pButton class="button-33" type="button" (click)="menu.toggle($event)" [ngStyle]="{'font-size': '0.7rem'}">
          <a><b>{{'FARMER_LOGIN'| translate}}</b></a>
        </button>
        <p-menu #menu [popup]="true" [model]="menuLoginItems"></p-menu>
        <button pButton class="button-33" type="button" [ngStyle]="{'font-size': '0.75rem'}"><a
          [routerLink]="['/vendor-registration-login']"><b>{{ 'VENDOR_REGISGTRATION'|translate}}</b></a></button>
  
        <button pButton class="button-33" type="button" [ngStyle]="{'font-size': '0.7rem'}"><a
            [routerLink]="['/tubewell-connection-login']"><b>{{ 'NOC_FOR_TUBEWELL_CONNECTION'|
              translate}}</b></a></button>
        <div class="language-translation social-icons">
          <label>{{'LANGUAGE' | translate}} </label>
          <p-dropdown [(ngModel)]="selectedLang" class="mr-4"
            [options]='[{name: "English", code:"en"}, {name: "Hindi",code:"hd"}]' optionLabel="name"
            (onChange)="languageChange($event)">
          </p-dropdown>
  
          <span>{{ "FOLLOW_US" | translate }} </span>
          <a href="https://www.facebook.com/share/12BhJki9f8j/?mibextid=LQQJ4d" target="_blank">
            <img src="../../../assets/home/logo/facebook.png" alt="New Item">
          </a>
          <a href="https://x.com/Micadaharyana" target="_blank">
            <img src="../../../assets/home/logo/x.png " alt="New Item">
          </a>
        </div>
      </div>
    </div> -->
</header>